import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const listPropertyResale = (propertyData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_PROPERTY_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project-resale/property-list`,
        propertyData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "LIST_PROPERTY_RESALE_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "LIST_PROPERTY_RESALE_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "LIST_PROPERTY_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewPropertyResale = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VIEW_PROPERTY_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/property-resale/view-property/${id}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "VIEW_PROPERTY_RESALE_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "VIEW_PROPERTY_RESALE_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_PROPERTY_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const statusPropertyResale = (statusData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "STATUS_PROPERTY_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/property-resale/property-status`,
        statusData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "STATUS_PROPERTY_RESALE_SUCCESS",
          payload: data,
        });
        toast.success(data?.message || "Status updated successfully");
        return data;
      } else {
        dispatch({
          type: "STATUS_PROPERTY_RESALE_FAILED",
          payload: data,
        });
        toast.error(data?.message || "Something went wrong");
      }
    } catch (error) {
      dispatch({
        type: "STATUS_PROPERTY_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addAdminMargin = (marginData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_ADMIN_MARGIN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      
      const { data } = await axios.post(
        `${BASE_URL}/property-resale/add-admin-margin`,
        marginData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_ADMIN_MARGIN_SUCCESS", payload: data });
        toast.success("Admin Margin Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_ADMIN_MARGIN_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_ADMIN_MARGIN_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Add failed!");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// Update Admin Margin  
export const updateAdminMargin = (marginData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_ADMIN_MARGIN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      
      const { data } = await axios.post(
        `${BASE_URL}/property-resale/update-admin-margin`,
        marginData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_ADMIN_MARGIN_SUCCESS", payload: data });
        toast.success("Admin Margin Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_ADMIN_MARGIN_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_ADMIN_MARGIN_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Update failed!");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getMarginHistory = (property_id) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_MARGIN_HISTORY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/property-resale/margin-history/${property_id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_MARGIN_HISTORY_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_MARGIN_HISTORY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_MARGIN_HISTORY_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Failed to fetch margin history!");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const listResaleInterestedProject = (projectData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_RESALE_INTERESTED_PROPERTY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/resale-interested-property/list`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "LIST_RESALE_INTERESTED_PROPERTY_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "LIST_RESALE_INTERESTED_PROPERTY_FAILED", payload: data });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "LIST_RESALE_INTERESTED_PROPERTY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateStatusResaleInterestedProject = (projectData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/resale-interested-property/status/update`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_SUCCESS",
          payload: data,
        });
        // toast.success(data?.message);
        return data;
      } else {
        dispatch({
          type: "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_FAILED",
          payload: data,
        });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_STATUS_RESALE_INTERESTED_PROPERTY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
